export const DE = {
    languageCode: "de",
    legal: {
        contact: "Kontakt",
        imprint: "Impressum",
        agb: "AGB",
        dataProtection: "Datenschutz",
    },
};
//# sourceMappingURL=de.js.map